import { createFileRoute } from "@tanstack/react-router";
import { ResetPasswordPage } from "@/features/auth";

/** Public: the emailed token is the credential. No sign-in required to get here. */
export const Route = createFileRoute("/reset-password/$token")({
  component: ResetPassword,
});

function ResetPassword() {
  const { token } = Route.useParams();
  return <ResetPasswordPage token={token} />;
}
